import React from "react";

/** Card content for `MouseOverPopover` help tooltips. */
const HelpPopoverCard = ({ title, description, link, language }) => (
    <div className="card">
        {title && <div className="card-header">{title}</div>}
        <div className="card-body">
            {description}
            {link && (
                <strong className="mx-2">
                    {" "}
                    <a href={link} target="_blank" rel="noreferrer">
                        {language?.popover?.this_link ?? "This Link"}
                    </a>
                </strong>
            )}
        </div>
    </div>
);

export default HelpPopoverCard;
